import { object, string, TypeOf } from 'yup';

export const ListBotTemplateFilterSchema = object({
  name: string(),
});

export type ListBotTemplateFilterType = TypeOf<
  typeof ListBotTemplateFilterSchema
>;
